import { render, staticRenderFns } from "./SpecialistCourtCase.vue?vue&type=template&id=2080008f"
import script from "./SpecialistCourtCase.vue?vue&type=script&lang=js"
export * from "./SpecialistCourtCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports